module.exports = __webpack_public_path__ + "img/zettabg.f23d35c8.jpg";